<template>
  <tr
  v-if="vmode===0">

    <td class="sticky">
      <div class="c-flex align-center">

        <v-btn
        icon
        text
        @click.stop="$emit('checkRow', item)">
          <v-icon :color="selected[item.tempID] ? 'color1' : ''"> 
            {{ selected[item.tempID] ? 'check_box' : 'check_box_outline_blank' }}
          </v-icon>
        </v-btn>

        <v-list-item-avatar
        :color="item.definition.name ? (lastVisited ? 'color1' : 'red lighten-2') : 'green accent-4'"
        class="ml-2 headline font-weight-light white--text">
          {{ (item.definition.name || '?').charAt(0) }}
        </v-list-item-avatar>
        <span class="ml-2 text-ellipsed" v-html="highlightedName">
          
        </span>
      </div>
    </td>

    <td>
      <c-ms-ii
      :metric_definition="item.definition" 
      :realValue.sync="item.quantity"
      :metric.sync="currentMetric"
      ></c-ms-ii>
    </td>

    <td>
      <c-cost-per-unit 
      :currencyLabel="currencyLabel"
      :realCost.sync="item.cost_per_unit"
      :definition="item.definition"
      :metric.sync="currentMetric" 
      :focussed.sync="costPerUnitHasFocus"></c-cost-per-unit>
    </td>

    <td>
      <c-price :quantity.sync="totalCost" :focussed.sync="totalCostHasFocus" :currency="currency">
      </c-price>
    </td>

    <td>
      <c-select-supplier fixed="true" :selectedID.sync="item.supplier_id"></c-select-supplier>
    </td>

    <td>
      <c-input :value.sync="item.batch_number"></c-input>
    </td>

    <td>
      <c-date :date.sync="item.expiry_date"></c-date>
    </td>
    
    <td>
      <c-input :value.sync="item.vat"></c-input>
    </td>
  </tr>

  <!-- MOBILE -->
  <div 
  v-else-if="vmode === 1"
  v-ripple
  :class="['c-flex-r mrow', {'selected-row': selected[item.tempID]}]">

    <v-icon 
    @click.stop="$emit('checkRow', item)"
    :color="selected[item.tempID] ? 'color1' : ''"> 
      {{ selected[item.tempID] ? 'check_box' : 'check_box_outline_blank' }}
    </v-icon>

    <v-list-item-avatar
    size="40"
    :color="item.definition.name ? (lastVisited ? 'color1--text' : 'red--text text--lighten-2') : 'green--text text--accent-4'"
    class="huge-text align-center">
      {{ (item.definition.name || '?').charAt(0) }}
    </v-list-item-avatar>

    <!--
    <img class="c-align-self-start" src="@/assets/img/illustrations/cardboard-box.png" alt="cardboard box" width="42px">
    -->
    
    <div class="c-flex-c1">
      <div 
      v-if="!item.definition.name"
      class="text-sans green--text text--accent-4">
        Select item
      </div>
      <template
      v-else>
        <div class="font-weight-bold">
          {{ item.definition.name }}
        </div>
        <div class="text-sans mt-1 font-weight-medium text--text text--darken-1">
          <c-ms-ii
          :metric_definition="item.definition" 
          :realValue.sync="item.quantity"
          :metric.sync="currentMetric"
          :key="item.id"
          labelMode
          ></c-ms-ii>

        </div>
        <!-- Extra column -->
        <div 
        class="text--text text--darken-1"
        >
          <div v-if="extraColumn === 'Supplier'">
            {{ supplier.name }}
          </div>
          <div v-if="extraColumn === 'Batch Number'">
            {{ item.batch_number }}
          </div>
          <div v-if="extraColumn === 'Expiry Date'">
            {{ expiryDate }}
          </div>
          <div v-if="extraColumn === 'Cost per unit'">
            {{ item.cost_per_unit }}
          </div>
          <div v-if="extraColumn === 'VAT'">
            {{ item.vat }}
          </div>
        </div>
      </template>
    </div>
  </div>

  <!-- DIALOG -->
  <div
  v-else-if="vmode === 2">
    <div class="text-xs-center">
      <img style="align-self: center;" src="@/assets/img/illustrations/cardboard-box.png" alt="cardboard box" width="80px">
    </div>

    <div class="inputcontainer">
      <div class="caption">
        Item
      </div>
      <c-select-inv-def 
      placeholder="Select item" 
      fixed="true" border="false" :selectedID.sync="item.inventory_item_id">
      </c-select-inv-def>
    </div>

    <div class="inputcontainer">
      <div class="caption">
        Quantity
      </div>

      <c-ms-ii
      :metric_definition="item.definition" 
      :realValue.sync="item.quantity"
      :metric.sync="currentMetric"
      ></c-ms-ii>
      
    </div>

    <div class="inputcontainer">
      <div class="caption">
        Cost per unit
      </div>
      <c-cost-per-unit 
      :realCost.sync="item.cost_per_unit"
      :definition="item.definition"
      :metric.sync="currentMetric" 
      :focussed.sync="costPerUnitHasFocus">
      </c-cost-per-unit>
    </div>
    
    <div class="inputcontainer">
      <div class="caption">
        Total cost
      </div>
      <c-price :quantity.sync="totalCost" :focussed.sync="totalCostHasFocus">
      </c-price>
    </div>

    <div class="inputcontainer">
      <div class="caption">
        Supplier
      </div>
      <c-select-supplier fixed="true" :selectedID.sync="item.supplier_id">
      </c-select-supplier>
    </div>
    
    <div class="inputcontainer">
      <div class="caption">
        Batch number
      </div>
      <c-input :value.sync="item.batch_number">
      </c-input>
    </div>
    
    <div class="inputcontainer">
      <div class="caption">
        Expiry date
      </div>
      <c-date :date.sync="item.expiry_date">
      </c-date>
    </div>
    
    <div class="inputcontainer">
      <div class="caption">
        VAT
      </div>
      <c-input :value.sync="item.vat"></c-input>
    </div>
  </div>
</template>

<script>
import {BigNumber} from 'bignumber.js'

export default {
  props: {
    vmode: null,
    searchText: null,
    item: null,
    extraColumn: null,
    selected: null,
    lastVisited: null,
    currency: null
  },
  data () {
    return {
      costPerUnitHasFocus: false,
      totalCostHasFocus: false,
      totalCost: 0,
      currentMetric: 0
    }
  },
  computed: {
    currencyLabel () {
      return (this.$store.state.db.currencies.items[this.currency] || {}).symbol
    },
    supplier () {
      return this.$store.state.db.suppliers.suppliers[this.item.supplier_id] || {}
    },
    expiryDate () {
      if (this.$moment.utc(this.item.expiry_date).isValid()) {
        return this.$moment(this.item.expiry_date).format('ddd DD/MM/YYYY')
      }
      return ''
    },
    automaticTotalCost () {
      return new BigNumber(this.quantityInUnits).times(this.item.cost_per_unit).toNumber()
      // return this.quantityInUnits * this.item.cost_per_unit
    },
    automaticCostPerUnit () {
      return new BigNumber(this.totalCost).dividedBy(this.quantityInUnits).toNumber()
    },
    quantityInUnits () {
      // in the new system lets save in the native metric?
      if (!this.item.definition) {
        return this.item.quantity
      }
      switch (this.item.definition.metric) {
        case 0:
          return this.item.quantity
        case 1:
          // ml - litres
          return new BigNumber(this.item.quantity).dividedBy(1000)
        case 2:
          // mg - kg
          return new BigNumber(this.item.quantity).dividedBy(1000 * 1000)
        case 3:
          // mm - m
          return new BigNumber(this.item.quantity).dividedBy(1000)
      }
    },
    highlightedName () {
      var replacedStr = (this.searchText || '').trim().split(/\s+/).map(x => x.replace(/[-[\]{}()*+!<=:?.\\^$|#\s,]/g, '\\$&')).join('|')
      replacedStr = this.item.definition.name.replace(new RegExp(replacedStr, 'gi'), '<span class="font-weight-regular">$&</span>')
      return '<span class="font-weight-bold">' + replacedStr + '</span>'
    }
  },
  watch: {
    automaticTotalCost (nv) {
      if (!this.totalCostHasFocus) {
        this.totalCost = nv
      }
    },
    automaticCostPerUnit (nv) {
      if (!this.costPerUnitHasFocus) {
        this.item.cost_per_unit = nv
        if (isNaN(this.item.cost_per_unit)) {
          this.item.cost_per_unit = 0
        }
      }
    }
  },
  created () {
    this.totalCost = this.automaticTotalCost
    console.log(this.item)
  }
}
</script>

<style scoped lang="scss">
.huge-text {
  font-size: 30px;
}
.mrow {
  padding: 8px;
  cursor: pointer;
  border-bottom: thin solid rgba(0,0,0,0.15);
  position: relative;
}
.mrow:hover {
  box-shadow: 0px 1px 3px rgba(0,0,0,0.35);
}
.selected-row {
  border-bottom: thin solid var(--v-color1-base);
  /* & ::v-deep .sticky-col {

  } */
}
.selected-row::before {
  background: var(--v-color1-base);
  height: 100%;
  width: 100%;
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  opacity: 0.1;
}
.inputcontainer {
  border-bottom: thin solid var(--v-hline-base);
  margin-bottom: 8px;

  & .caption {
    color: var(--v-text-darken1);
  }

  &:focus-within .caption {
    color: var(--v-color1-base);
  }

  & .crx-input {
    margin-top: 0px;

    &:before {
      content: none;
    }
  }
}
</style>
